module.exports = __webpack_public_path__ + "static/img/menage10.95457050.jpg";